export default "__VITE_ASSET__BpGOTh43__"